import { PAGE_PARAMS } from '../T3/_params';
import * as AJAX from '../T3/ajax';

const onSuccessCrossContentTeaser = (params, caller, data) => {
  console.log(caller);
};

const crossContentTeaser = () => {
  const AJAX_TYPENUM = 1728508483;
  const PAGE_UID = $('html').data('page-id');
  const URL = `/?id=${PAGE_UID}&type=${AJAX_TYPENUM}`;

  const CE_CONTAINER = $('.ce--cross-content-teaser');

  if (CE_CONTAINER.length === 0) {
    return;
  }

  CE_CONTAINER.each(function() {
    const CE_UID = $(this).data('uid');
    const TEASER_PLACEHOLDER = $(this).find('.teaser.ajax');

    if (TEASER_PLACEHOLDER.length === 0) {
      return false;
    }
    let requestData = new FormData();
    requestData.append('ceUid', CE_UID);
    requestData.append('pageUid', PAGE_UID);

    $.ajax({
      async: 'true',
      type: 'POST',
      data: requestData,
      cache: false,
      processData: false,
      contentType: false,
      url: URL,
      crossDomain: true,
      dataType: 'html',
    }).done(function(response) {
      TEASER_PLACEHOLDER.replaceWith(response);
    });
  });
};

document.addEventListener('DOMContentLoaded', function() {
  crossContentTeaser();
});
